














import { View } from 'client-website-ts-library/plugins';
import { Component, Mixins } from 'vue-property-decorator';
import Form from '../components/Forms/Form.vue';
import GoogleReviews from '../components/GoogleReviews.vue';

@Component({
  components: {
    Form,
    GoogleReviews,
  },
})
export default class RentalAppraisal extends Mixins(View) {
}
